import React, { useState } from "react";

import ajaxMethods from "../../../api/ajax-methods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { MDBDataTable } from "mdbreact";
import {
  loanScheduleColumns,
  reOrderTableData,
} from "../../../redux/actions/loans";
import { Loader } from "../../../UI/Loaders/Loaders";
import { enforceMaxLength } from "../../../helpers/enforceMaxLength";
import { appInsights } from "../../../config/appInsights";

export const LoanSchedule = (props) => {
  const [bvn, setBvn] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({});

  const getCreditReport = (e) => {
    e.preventDefault();
    props.clearToast();
    if (!bvn || !bvn.length) {
      return props.onSetToast("error", "Please enter your BVN");
    }
    setLoading(true);
    ajaxMethods
      .get(ajaxEndpoints.GET_LOAN_SCHEDULE + "?bvn_number=" + bvn)
      .then((response) => {
        setLoading(false);
        if (response) {
          const reOrderedTableData = reOrderTableData(
            loanScheduleColumns,
            response.data
          );
          setTableData(reOrderedTableData);
        } else {
          props.onSetToast("error", "BVN does not exist.");
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "LoanSchedule.js",
          },
        });
        setLoading(false);
        props.onSetToast("error", error.message);
      });
  };

  if (loading)
    return <Loader text="Loading loan schedule..." centered="true" />;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="card animated speed-1x fadeInRight"
          style={{ width: "auto" }}
        >
          <div className="body text-center">
            <h3 className="m-t-0">
              <i className="adv-icon fas fa-cogs" />
              &nbsp; Loan Schedule
            </h3>
            <p className="settings-block text-muted">
              Verify the Loan Schedule for a Borrower
            </p>
            <form onSubmit={getCreditReport}>
              <label className="label-txt">BVN</label>
              <div className="form-group inputWithIcon">
                <input
                  type="number"
                  className="user__form form-control"
                  placeholder="Enter Bank Verification Number"
                  autoComplete="off"
                  name="treshold_amount"
                  value={bvn}
                  onKeyPress={enforceMaxLength}
                  maxLength="11"
                  required
                  onChange={(e) => setBvn(e.target.value)}
                />
                <i className="fas fa-lock" />
              </div>

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn login-btn"
                  data-form="investment"
                  disabled={loading}
                >
                  {/* {loading &&
                                    <span className="spinner-border spinner-border-sm ml-3"></span>
                                } */}
                  <i className="fas fa-share" />
                  &nbsp; Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {!loading && Object.keys(tableData).length > 0 && (
        <div className="grid__padding animated speed-1x fadeInRight">
          <MDBDataTable
            className="text-center"
            responsive
            minimal="true"
            striped
            bordered
            hover
            data={tableData}
          />
        </div>
      )}
    </div>
  );
};
